import api from "./config";

// 📌 NOTIFICACIONES (Bandeja del doctor)

// Obtener todas las notificaciones del doctor logueado
export const getNotificaciones = async () => {
  try {
    const response = await api.get("/notificaciones/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo notificaciones:", error);
    return [];
  }
};

// Obtener solo el conteo de no leídas (para la campanita)
export const getNotificacionesNoLeidas = async () => {
  try {
    const response = await api.get("/notificaciones/no-leidas/");
    return response.data.count;
  } catch (error) {
    console.error("Error obteniendo conteo de no leídas:", error);
    return 0;
  }
};

// Marcar click en una notificación (implica también leída)
export const marcarNotificacionClick = async (id) => {
  try {
    const response = await api.patch(`/notificaciones/${id}/click/`);
    return response.data;
  } catch (error) {
    console.error("Error marcando click en notificación:", error);
    return null;
  }
};

// Obtener estado del onboarding del doctor logueado
export const getEstadoOnboarding = async () => {
  try {
    const response = await api.get("/onboarding/estado/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo estado de onboarding:", error);
    return null;
  }
};

// Marcar que el doctor visitó la configuración de cuestionario
export const marcarCuestionarioVisitado = async () => {
  try {
    const response = await api.post("/onboarding/cuestionario-visitado/");
    return response.data;
  } catch (error) {
    console.error("Error marcando cuestionario visitado:", error);
    return null;
  }
};

// Marcar todas las notificaciones como leídas (al abrir la campanita)
export const marcarNotificacionesLeidas = async () => {
  try {
    const response = await api.post("/notificaciones/marcar-leidas/");
    return response.data;
  } catch (error) {
    console.error("Error marcando notificaciones como leídas:", error);
    return null;
  }
};

// Sincronizar notificaciones de pago (se llama al entrar al dashboard inicio)
export const sincronizarNotificacionPago = async () => {
  try {
    const response = await api.post("/notificaciones/sincronizar-pago/");
    return response.data;
  } catch (error) {
    console.error("Error sincronizando notificación de pago:", error);
    return null;
  }
};